import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import { Breadcrumb } from 'xland-ui';
import InternalForm from 'components/InternalForm';
import useDialog from 'components/Dialog/useDialog';
import usePositionBreadcrumb from 'routes/MyInvestments/hooks/usePositionBreadcrumb';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import roles, { ROLE_ADMIN, ROLE_MENTOR, ROLE_USER } from 'constants/roles';
import {
  ROUTE_MENTOR_PATH,
  ROUTE_STARTUP_PATH,
  ROUTE_ADMIN_PATH,
  ROUTE_POSITION_PATH,
} from 'routes';
import './styles.scss';

function EditInfo({
  user,
  company = null,
  fetchCompany = () => { },
  literals,
  type,
  match,
  editStartup,
  editMentor,
  editInvestor,
}) {
  const { dialog } = useDialog();
  const navigate = useNavigate();
  const literalsCommon = useSelector(state => state.i18n.literals.common);

  useEffect(() => {
    if (type === 'startup' && !company?.loading) {
      (async () => {
        if (!company || company.company.id !== match.params.id) {
          await fetchCompany(match.params.id);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, match.params.id]);

  const getAnswers = () => {
    if (type === roles.ROLE_MENTOR) {
      return user.mentor;
    }
    if (type === roles.ROLE_INVESTOR) {
      return user.investor;
    }
    return company.company;
  };

  const goBack = () => {
    if (type === 'startup' && user?.role?.includes(ROLE_USER)) {
      navigate(ROUTE_STARTUP_PATH.setViewStartup(company.company.id));
    } else if (type === 'mentor' && user?.role?.includes(ROLE_MENTOR)) {
      navigate(ROUTE_MENTOR_PATH.HOME);
    } else if (type === 'startup' && user?.role?.includes(ROLE_ADMIN)) {
      navigate(ROUTE_ADMIN_PATH.STARTUPS);
    }
  };

  const updateInfo = async (answers) => {
    if (type === 'startup') {
      await editStartup(match.params.id, answers);
    } else if (type === 'mentor') {
      await editMentor(answers, user);
    } else if (type === 'investor') {
      await editInvestor(answers, user);
    }
    await dialog({
      text: literals.profileUpdated,
      type: 'alert',
    });
    goBack();
  };

  const formButtons = [
    { type: 'submit', onClick: updateInfo, text: literals.save },
    { onClick: goBack, text: literals.cancel, color: 'secondary' },
  ];

  const { routes, nextRoutes } = usePositionBreadcrumb(ROUTE_POSITION_PATH.EDIT_INVESTOR);

  return (
    <div className='edit-info-wrapper'>
      {type === 'investor' ? (
        <Breadcrumb routes={routes} nextRoutes={nextRoutes} />
      ) : (
        <Breadcrumb routes={[
          { name: literalsCommon.startup, path: ROUTE_STARTUP_PATH.setViewStartup(company.company.id) },
          { name: literalsCommon.edit },
        ]}
        />
      )}
      {
        type === 'startup' && !(company.company.id === match.params.id && company.loaded) ? (
          <Loading mode='tool' />
        ) : (
          <InternalForm answers={getAnswers()} type={type} buttons={formButtons} />
        )
      }
    </div>
  );
}

EditInfo.propTypes = {
  user: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  company: PropTypes.object,
  fetchCompany: PropTypes.func,
  editStartup: PropTypes.func.isRequired,
  editMentor: PropTypes.func.isRequired,
  editInvestor: PropTypes.func.isRequired,
};

export default EditInfo;
